import script from "./country-deals.vue?vue&type=script&setup=true&lang=js"
export * from "./country-deals.vue?vue&type=script&setup=true&lang=js"

import "./country-deals.vue?vue&type=style&index=0&id=7e960f7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e960f7c"]])

export default __exports__